import {useSelector} from "react-redux";
import {selectCurrentRefreshToken, selectCurrentToken} from "../features/authentication/authenticationSelectors";

export const useAuth = () => {
    const token = useSelector(selectCurrentToken);
    const refreshToken = useSelector(selectCurrentRefreshToken);

    return token && refreshToken;
};